import type { ToastType } from '../../constants/toast';
import uiSlice from '../slices/ui-slice';

export const getShowToastAction = (type: ToastType) =>
  uiSlice.actions.showToast({ type });

export const getHideToastAction = () => uiSlice.actions.hideToast(null);
